module.exports = __webpack_public_path__ + "img/bannerRed.b677b839.jpg";